import _ from 'lodash'

import {
  CLEAR_FILTER,
  RESET_FILTER_STATE,
  UPDATE_FILTER,
  UPDATE_MULTIPLE_FILTERS,
} from '../actions/applyFilters'
import { SET_CURRENT_PAGE } from '../actions/setCurrentPage'
import { SET_SORT_ORDER } from '../actions/applySortOrder'

const initialState = 0

export default function pagination(state = initialState, action) {
  switch (action.type) {
    case CLEAR_FILTER:
    case RESET_FILTER_STATE:
    case SET_SORT_ORDER:
    case UPDATE_FILTER:
    case UPDATE_MULTIPLE_FILTERS:
      return initialState
    case SET_CURRENT_PAGE:
      return action.payload
    default:
      return state
  }
}

export const getCurrentPage = state => _.get(state, 'pageData')
